// The rule match operators, shared by every surface that creates or edits a
// rule (the rule editor, the merge dialog, and the attribution-suggestion
// dialog). SUBSTRING/PREFIX/EXACT are index-backed; REGEX is the slow fallback.
export const MATCH_KINDS = [
  { value: "SUBSTRING", label: "Contains", hint: "matches anywhere in the description (indexed)" },
  { value: "PREFIX", label: "Starts with", hint: "matches the start of the description (indexed)" },
  { value: "EXACT", label: "Is exactly", hint: "the whole description equals the value (indexed)" },
  { value: "REGEX", label: "Matches regex", hint: "POSIX pattern — slowest; use for wildcards/anchors" },
];
